export default {
  pre: {
    padding: 24,
    borderRadius: 10
  }
}



// WEBPACK FOOTER //
// ./src/docs/CodeExample/styles.js